import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { AppConfig } from '../../../app.config';
import { Router, ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../services/helpers.service';
import { UserService } from '../../../services/user.service';
import { BroadcastService } from '../../../services/broadcast.service';
import { NotificationService } from '../../../services/notification.service';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
  providers: [MessageService],
})
export class InsuranceComponent implements OnInit {
  public menuOpen = true;
  public dropMenuOpen = false;
  public userName: string = '';
  public profile: any = {};
  public menuItems: any = [];
  public insuranceCompanyMenu: any = [];
  public RawMenu: any = [];
  public adminSetupItems: any = [];
  public PolicyHolderMenu: any = [];
  public showShadow: boolean = false;
  //public roleID: number = 0;
  public roles: any = [];

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public router: Router,
    public messageService: MessageService,
    private translate: TranslateService,
    public modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.profile = this.helpersService.getProfileData();
    this.roles = this.helpersService.getProfileInsuranceRoles();
    //this.roleID = roles ? roles.roleID : null;
    //console.log(this.roleID);

    this.generateMenus();
  }

  closeMenu() {
    if (!this.menuOpen) {
      this.menuOpen = !this.menuOpen;
    }
  }

  generateMenus() {
    const partner = this.helpersService.getPartnerData();

    this.RawMenu = [
      {
        label: 'Quicklinks',
        separator: true,
        items: [
          //{
          //  label: "Dashboard",
          //  //label: this.translate.instant("bikeshop.menu.services"),
          //  icon: "fa fa-fw fa-dashboard",
          //  routerLink: ["/insurance/dashboard"],
          //  command: () => {
          //    this.closeMenu();
          //  }
          //},
          {
            label: 'Create Claim',
            //label: this.translate.instant("bikeshop.menu.services"),
            icon: 'fa fa-fw fa-file-text-o',
            routerLink: ['/insurance/claim'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            label: 'All Tasks',
            //label: this.translate.instant("bikeshop.menu.calendar"),
            icon: 'fa fa-fw fa-tasks',
            routerLink: ['/insurance/tasks'],
            command: () => {
              this.closeMenu();
            },
          },
          {
            label: 'All Claims',
            //label: this.translate.instant("bikeshop.menu.calendar"),
            icon: 'fa fa-fw fa-files-o',
            routerLink: ['/insurance/claims'],
            command: () => {
              this.closeMenu();
            },
          },
        ],
      },
    ];

    var isInsurance = false;
    for (var i = 0; i < this.roles.users.length; i++) {
      if (
        this.roles.users[i].roleID === 5 ||
        this.roles.users[i].roleID === 8
      ) {
        this.menuItems = this.RawMenu;
        isInsurance = true;
      }
    }

    if (isInsurance)
      this.adminSetupItems = [
        {
          label: this.translate.instant('bikeshop.menu.setup'),
          icon: 'fa fa-fw fa-cog',
          items: [
            {
              label: this.translate.instant('bikeshop.menu.users'),
              icon: 'fa fa-fw fa-users',
              routerLink: ['/store/users'],
              command: () => {
                this.closeMenu();
              },
            },
            {
              label: this.translate.instant('bikeshop.menu.purchase_bundle'),
              icon: 'fa fa-fw fa-comments',
              routerLink: ['/store/purchase-messaging-bundle'],
              command: () => {
                this.closeMenu();
              },
            },
            {
              label: 'Claim Statuses',
              icon: 'fa fa-fw fa-cog',
              routerLink: ['/store/message-templates'],
              command: () => {
                this.closeMenu();
              },
            },
          ],
        },
      ];
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;

    if (pos == max) {
      this.showShadow = false;
    } else {
      this.showShadow = true;
    }
  }
}

